import { IServices } from "@netent/origin";
import { IMenuState } from "@netent/playui";
import { FeatureStateCreator } from "../../types";

export const menuState: FeatureStateCreator<IMenuState> = (
  services: IServices
): IMenuState => ({
  enabled: !services.gameRound.isRoundActive()
});
